import React from "react";
// import Location from "./TaskLocation";
import { Link, withRouter } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { API_HOST } from "../utils/api-config";

class CompleteTasks extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props;
  }
  render() {
    const { route, completedTasks } = this.props.tasksInfo;
    // console.log(task);

    return (
      <div>
        <h4 className="text-center">
          Route {route.id} - {route.delivery_ids.length}{" "}
          {route.delivery_ids.length > 1 ? "deliveries" : "delivery"}
        </h4>
        <Accordion>
          {completedTasks.map((tsk, i) => {
            let variant = "outline-success";
            return (
              completedTasks[i].complete && (
                <Card key={i}>
                  <Accordion.Toggle
                    as={Button}
                    variant={variant}
                    eventKey={`${completedTasks[i].id}`}
                  >
                    {completedTasks[i].started_at &&
                      completedTasks[i].started_at.split("T")[1].split(".")[0]}
                    --&gt; {completedTasks[i].title} --&gt;{" "}
                    {completedTasks[i].completed_at.split("T")[1].split(".")[0]}
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={`${completedTasks[i].id}`}>
                    <Card.Body>
                      {completedTasks[i].name}{" "}
                      {completedTasks[i].task_type === "delivery" &&
                        `(${completedTasks[i].merchant} - 
                      ${completedTasks[i].orders[0]})`}
                      <br></br>
                      {completedTasks[i].address1} {completedTasks[i].address2},{" "}
                      {completedTasks[i].city}, {completedTasks[i].province},{" "}
                      {completedTasks[i].postal_code} <br></br>
                      Instructions:{" "}
                      {completedTasks[i].delivery_instructions &&
                        completedTasks[i].delivery_instructions}
                      <br></br>
                      <a
                        href={
                          completedTasks[i].task_type == "delivery"
                            ? `${API_HOST}/loc?t=${completedTasks[i].id}&r=${completedTasks[i].orders[0]}`
                            : completedTasks[i].pick_up
                            ? `${API_HOST}/loc?t=${
                                completedTasks[i].id
                              }&r=${completedTasks[i].orders[0]
                                .split(" ")[0]
                                .slice(1)}`
                            : `${API_HOST}/loc?t=${completedTasks[i].id}&r=${completedTasks[i].merchant_id}`
                        }
                        target="_blank"
                      >
                        <Button variant="primary">Tracking View</Button>
                      </a>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )
            );
          })}
        </Accordion>
      </div>
    );
  }
}

export default withRouter(CompleteTasks);
